import { Reveal } from "./Reveal";

const Universo = () => (
  <section id="universo" data-testid="universo-section" className="py-16 md:py-24 bg-brand-charcoal text-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal>
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-pink">
          Universo CROC
        </p>
        <h2 className="text-balance mt-3 font-display font-bold tracking-tight text-3xl md:text-4xl">
          CROC no es solo un sonido.{" "}
          <span className="text-brand-pink">Es una forma de comerse la vida.</span>
        </h2>
        <p className="mt-4 text-base md:text-lg text-white/70 leading-relaxed">
          Detrás de CROC LAB hay una comunidad que entiende la comida como un
          momento para disfrutar sin complejos. Un universo de marca propio,
          reconocible desde el escaparate hasta el último bocado.
        </p>
        <ul className="mt-8 flex flex-wrap gap-3">
          {["Crujiente siempre", "Sin reglas", "Hecho en Valencia"].map((tag) => (
            <li
              key={tag}
              data-testid={`universo-tag-${tag.toLowerCase().replace(/ /g, "-")}`}
              className="text-sm font-semibold text-white/85 border border-white/20 rounded-full px-4 py-2"
            >
              {tag}
            </li>
          ))}
        </ul>
      </Reveal>
      <Reveal delay={0.15} className="flex justify-center lg:justify-end">
        <div className="relative">
          <div className="absolute inset-0 m-auto w-56 h-56 md:w-72 md:h-72 bg-brand-pink/20 rounded-full" aria-hidden="true" />
          <img
            src="/brand/croc-mascot.png"
            alt="Insignia de la mascota de CROC LAB"
            data-testid="universo-mascot-image"
            className="relative w-52 md:w-72 h-auto rounded-full shadow-2xl -rotate-3"
          />
        </div>
      </Reveal>
    </div>
  </section>
);

export default Universo;
